<script setup lang="ts">
type CTA = { label: string; to: string }

const { title, description, iconName, cta } = defineProps<{
  title: string
  description?: string
  iconName?: string
  cta?: CTA
}>()
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-black/[0.12] bg-white p-10 text-center"
  >
    <div
      v-if="iconName || $slots.icon"
      class="flex size-12 items-center justify-center rounded-full bg-black-05 text-black-60"
    >
      <slot name="icon">
        <UIIcon v-if="iconName" :name="iconName" size="md" />
      </slot>
    </div>
    <h3 class="font-serif text-[20px] leading-snug text-black-100">{{ title }}</h3>
    <p v-if="description" class="max-w-[44ch] text-sm text-black-60">{{ description }}</p>
    <NuxtLink
      v-if="cta"
      :to="cta.to"
      class="mt-2 inline-flex h-10 items-center justify-center gap-1 rounded-lg bg-gold-primary-100 px-5 text-sm font-semibold text-black-100 transition-colors hover:bg-gold-primary-120"
    >
      {{ cta.label }}
      <span
        aria-hidden="true"
        class="rtl:inline-block rtl:-scale-x-100"
        >&rarr;</span
      >
    </NuxtLink>
  </div>
</template>
